import React from 'react'
import pluralize from 'pluralize'
import { Chat } from '@trustero/trustero-api-web/lib/chat/chat_pb'
import { InfoButton } from 'src/components/PageLayout/InfoButton'
import {
  Tooltip,
  TooltipOverlayType,
  TooltipPositions,
} from 'src/components/Reusable/Tooltip/Tooltip'
import { ChatInfoIcon } from './chatPanel.styles'

// Who created the chat: its owner, or for a chat with none (a vendor
// evaluation's) whoever started it.
export const chatCreatorName = (chat?: Chat): string =>
  chat?.getOwner()?.getName() ||
  chat?.getOwner()?.getEmail() ||
  chat?.getInitiatedBy() ||
  'Unknown'

// The info icon beside a chat's title, in TI and the copilot.
export const ChatInfoTooltip = ({
  id,
  isReadOnly,
  ownerName,
  aiQuestionCredits,
}: {
  id: string
  isReadOnly: boolean
  ownerName: string
  // Undefined until the first messages poll brings it.
  aiQuestionCredits?: number
}): JSX.Element => (
  // Stops the click here: inside an editable title, it would open the title for editing.
  <ChatInfoIcon onClick={(e) => e.stopPropagation()}>
    {/* Not InfoTooltip: its icon is a span, which the keyboard can't reach. */}
    <Tooltip
      id={id}
      trigger={['hover', 'focus']}
      placement={TooltipPositions.bottom}
      overlayType={TooltipOverlayType.popover}
      tooltipBody={
        <>
          {isReadOnly
            ? `Chat created by ${ownerName}. Title not editable.`
            : 'Chat created by you.'}
          {aiQuestionCredits !== undefined && (
            <>
              <br />
              {pluralize('AI question credit', aiQuestionCredits, true)} used.
            </>
          )}
        </>
      }
    >
      <InfoButton type="button" aria-label="Chat info" ml="xs" />
    </Tooltip>
  </ChatInfoIcon>
)
